import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const unApprovedCustomersApi = "/api/v2/accountnewcustomer/unapprovedcustomers";

export interface UnApprovedCustomersModel {
    uri?: string;
    unApprovedCustomers?: UnApprovedCustomer[];
    properties?: Properties;
}

export interface UnApprovedCustomer {
    id?: string;
    customerNumber?: string;
    companyName?: string;
    businessType?: string;
    status?: string;
}

export interface Properties {}

export interface UnApprovedCustomersParameter extends ApiParameter {}

export async function getUnApprovedCustomers(parameter: UnApprovedCustomersParameter) {
    const response = await get<UnApprovedCustomersModel>(unApprovedCustomersApi, parameter);
    return response;
}
